import Vue from "vue";
import Router from "vue-router";
import Index from "./views/index.vue";
import { cancelRequests } from "@/api/lib";
Vue.use(Router);

let router = new Router({
  // mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
      redirect: "/homeMarket",
      meta: {
        title: "企服集市",
        keepAlive: false, //此组件不需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      },
    },
    {
      path: "/homeMarket",
      name: "homeMarket",
      component: (resolve) =>
        require(["@/views/homeMarket/homeMarket.vue"], resolve),
      meta: {
        title: "企服集市",
        keepAlive: true, //需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      },
    },
    {
      path: "/serviceList",
      name: "serviceList",
      component: (resolve) =>
        require(["@/views/serviceList/serviceList.vue"], resolve),
      meta: {
        title: "服务列表",
        keepAlive: true,
      },
    },
    {
      path: "/serviceDetail",
      name: "serviceDetail",
      component: (resolve) =>
        require(["@/views/serviceList/serviceDetail/serviceDetail.vue"], resolve),
      meta: {
        title: "服务详情",
      },
    },
    {
      path: "/demandList",
      name: "demandList",
      component: (resolve) =>
        require(["@/views/demandList/demandList.vue"], resolve),
      meta: {
        title: "需求列表",
        keepAlive: true,
      },
    },
    {
      path: "/demandDetail",
      name: "demandDetail",
      component: (resolve) =>
        require(["@/views/demandList/demandDetail/demandDetail.vue"], resolve),
      meta: {
        title: "需求详情",
      },
    },
    {
      path: "/providerList",
      name: "providerList",
      component: (resolve) =>
        require(["@/views/providerList/providerList.vue"], resolve),
      meta: {
        title: "服务商列表",
        keepAlive: true,
      },
    },
    {
      path: "/providerDetail",
      name: "providerDetail",
      component: (resolve) =>
        require(["@/views/providerList/providerDetail/providerDetail.vue"], resolve),
      meta: {
        title: "服务商详情",
      },
    },
    {
      path: "/providerDetailLink",
      name: "providerDetailLink",
      component: (resolve) =>
        require(["@/views/providerList/providerDetail/providerDetailLink.vue"], resolve),
      meta: {
        title: "服务商详情",
      },
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.name === "homeMarket") {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  cancelRequests(); // 终止进行中的请求
  next();
});
router.afterEach(() => {
  // 在每次路由跳转后执行滚动到顶部的操作
  window.scrollTo(0, 0);
})

export default router;
